var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal fade"tabindex="-1"role="dialog"> <div class="modal-dialog"data-bind="css: options.css"> <div class="modal-content"> <div class="modal-header"><!-- ko if: options.userCanClose --> <button type="button"class="nfd-modal-btn-close dms-btn-close btn dms-btn-secondary icon-btn-XS"data-dismiss="modal"aria-label="Закрыть диалог"> <i class="nfd-icon dms-icon-Close2025"aria-hidden="true"></i> </button><!-- /ko --> <h4 class="modal-title"> <b data-bind="text: options.title"></b> </h4> </div> <div class="modal-body"data-bind="template: options.template"></div> </div> </div> </div>';
}
return __p;
};
